import { Navigate, useLocation } from "react-router-dom";
import type { Role } from "@/types/auth";
import { ROLE_HOME } from "@/lib/roles";
import { useAuthStore } from "@/stores/auth.store";

/** Gate a route on authentication and (optionally) a specific role. */
export function ProtectedRoute({
  role,
  children,
}: {
  role?: Role;
  children: React.ReactNode;
}) {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={ROLE_HOME[user.role]} replace />;
  }
  return <>{children}</>;
}
